/**
 * Monta o conteúdo das regras de premiação a partir da configuração do Cockpit.
 */

export function formatPrizeCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(value) || 0)
}

/**
 * @param {object} params
 * @param {Array<{ value: number, prize: number, top_seller_prize?: number }>} params.milestones
 * @param {number} params.monthlyGoal
 */
export function buildCockpitPrizeRulesContent({
  milestones = [],
  monthlyGoal = 0,
}) {
  const sortedMilestones = [...milestones].sort((a, b) => a.value - b.value)

  return {
    title: 'Premiação por Meta Coletiva da Empresa',
    milestoneTable: sortedMilestones.map((m) => ({
      value: formatPrizeCurrency(m.value),
      prize: formatPrizeCurrency(m.prize),
      topSellerPrize: formatPrizeCurrency(m.top_seller_prize ?? 0),
    })),
    sections: [
      {
        title: '1. Prêmio coletivo por patamar',
        paragraphs: [
          'A premiação é calculada com base no faturamento total da empresa no mês (soma das vendas das vendedoras elegíveis).',
          'Cada marco define o prêmio geral do patamar atual. Ao ultrapassar um marco, todas as vendedoras elegíveis passam a receber o valor daquele nível — não é cumulativo.',
        ],
      },
      {
        title: '2. Prêmio líder por patamar',
        paragraphs: [
          'A vendedora com o maior faturamento individual no mês recebe o prêmio líder do patamar coletivo atual da empresa.',
          'Mesmo antes da empresa atingir o primeiro marco global, a líder já recebe o prêmio individual do primeiro patamar configurado.',
          'Em caso de empate no faturamento individual, o critério de desempate é o menor ID de usuário no sistema.',
        ],
      },
      {
        title: '3. Prêmio por liderança consecutiva (folhas)',
        paragraphs: [
          'A vendedora com o maior faturamento individual no mês inicia ou continua a sequência de liderança, representada por ícones de folha no Cockpit.',
          'Cada mês consecutivo no topo acumula uma folha. Com 2 folhas (2 meses seguidos como líder), a premiação é meio período de folga (manhã). Com 3 folhas (3 meses seguidos), a premiação é 1 dia de folga — e o ciclo reinicia em seguida.',
          'O dia ou período de folga será definido pela empresa, conforme conveniência operacional.',
        ],
      },
      {
        title: '4. Critérios de elegibilidade (Assiduidade e Comprometimento)',
        paragraphs: [
          'Para ter direito a receber qualquer um dos prêmios da tabela, a vendedora deve manter uma conduta de excelência no dia a dia. A premiação individual será retida ou cancelada no mês se ocorrer qualquer uma das situações abaixo:',
        ],
        bullets: [
          'Assiduidade e Pontualidade: mais de 1 falta injustificada ou mais de 3 atrasos injustificados no mês.',
          'Comprometimento e Processos: deixar de registrar informações no sistema/CRM, omitir dados de clientes ou descumprir deliberadamente os processos internos.',
          'Clima Organizacional: receber advertência formal por escrito no mês devido a problemas de conduta, falta de ética com colegas ou falta de postura com o cliente.',
        ],
        footer:
          'O não cumprimento desses critérios desqualifica a vendedora da premiação daquele mês, mas as vendas dela continuam contando para a meta coletiva da empresa.',
      },
    ],
    metaLabel: monthlyGoal > 0 ? formatPrizeCurrency(monthlyGoal) : null,
  }
}
